import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { Param, paramsConstants } from '../types/params.types';
 
const entityConstants = paramsConstants
 
const fetchParams = async (): Promise<Param[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}/editables/`);
	return response?.data;
};
 
export const useParams = () => {
	return useQuery<Param[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => fetchParams(),
		// staleTime: 5 * 60 * 1000,
		enabled: true,
	});
};